import React, { useEffect } from "react"
import Image from "next/image"
import imgBottom from "assets/img/image/img_about-bottom.png"

//Utils
import { useRouter } from "next/router"
import {
  useIsomorphicLayoutEffect,
  useScrollAnim,
} from "@components/hooks/hooks"
import YouTube from "react-youtube"

const HandmadeComp = ({ locale, locales }) => {
  //Utils
  const Router = useRouter()
  const [trigger, anim] = useScrollAnim()

  // useIsomorphicLayoutEffect(() => {
  //   document.documentElement.classList.add("enable-sticky")
  // }, [])
  //React Operations ******************************************************************** //

  const videoOptions = {
    playerVars: {
      autoplay: 0,
      controls: 1,
      rel: 0,
      showinfo: 0,
      mute: 0,
      color: "white",
      fs: 1,
      modestbranding: 1,
    },
  }

  return (
    <div className="sc-handmade" ref={trigger}>
      <div className="container mw-lg">
        <div className={`wrapper-content ${anim(1)}`}>
          <div className="embed-responsive embed-responsive-16by9">
            <YouTube
              videoId="udOQwzw-B9g"
              opts={videoOptions}
              className="embed-responsive-item"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HandmadeComp
